export default {
  title: '大師航拍',
  // 首页卡片样片上那颗「看样片」药丸按钮
  videoPill: {
    watchSample: '看樣片',
  },
  appMenu: {
    title: '選單',
    scan: '掃碼',
    language: '語言',
    notice: '消息',
    service: '客服',
    setting: '設置',
  },
  tabBar: {
    aerial: '航拍',
    masterMap: '大師地圖',
    home: '首頁',
    memory: '回憶',
    profile: '我的',
    order: '訂單',
    exchange: '兌換',
    community: '航拍圈',
    noDataPopup: {
      title: '無此打卡點',
      content: '您可移至其他打卡點掃描二維碼',
    },
    spotNotMatch: {
      title: '訂單不適用於該打卡點',
      content: '請前往下單的打卡點掃碼使用',
    },
    success: {
      title: '訂單匹配成功',
      content: '您當前還沒有可使用的訂單哦~',
    },
    fail: {
      title: '訂單匹配失敗',
      content: '請重新嘗試掃碼或諮詢客服~',
    },
    livestreamFail: {
      title: '航拍啟動失敗',
      content: '非常抱歉，由於本次航拍遇到阻礙無法使用。訂單將會自動退款，請留意退款消息。',
    },
    notHotspotQrcode: '非有效打卡點二維碼',
    exceededUsageTime: '已超過使用時間',
    expiredTicket: '當前狀態無法使用',
  },
  homePage: {
    noHotspotNearby: '附近還沒有打卡點，換個位置看看',
    matchingNearby: '正在為你匹配最近航拍點',
    matchedNearby: '已為你匹配最近的景點',
    nearerSpot: '{name} 離你近 {gain}',
    nearerSpotPlain: '{name} 離你更近',
    nearerSpotAction: '去看看',
    allAirlines: '全部航線',
    distanceAbout: '距離約 {distance}',
    routeDisplay: '路線展示',
    noRouteData: '這條航線暫無路線數據',
    nearestSession: '拍攝時間',
    bookingLocking: '正在鎖定班次',
    bookingCreated: '訂單已建立',
    bookingPaying: '正在調起支付',
    bookingHint: '請勿關閉頁面',
    today: '今天',
    tomorrow: '明天',
    sessionDate: '日期',
    sessionTime: '時間',
    hotspotIndex: '打卡點 {index}/{total}',
    swipeForMore: '下滑更多內容',
    alreadyBottom: '已經到底啦~',
    alreadyTop: '已經到頂啦~',
    pullToRefresh: '繼續拉會刷新頁面',
    releaseToRefresh: '鬆開刷新',
    refreshing: '正在刷新',
    refreshDone: '刷新完成',
    noSessionToday: '今日已約滿',
    attractionCard: {
      loginToReservation: '登錄後預訂航拍',
      workingTime: '營業時間',
    },
    checkinCard: {
      desc: '已開始啦~',
      buttonText: '一鍵航拍',
    },
    orderPopup: {
      desc: '您預約的航線已開始啦',
      buttonText: '去航拍',
    },
    loginTipsBar: {
      desc: '立即登錄大師航拍體驗完整功能',
      buttonText: '去登錄',
    },
    runningJourneyTipsBar: {
      desc: '您有一個大師航線正在進行中',
      buttonText: '進入',
    },
    selectFlightPage: {
      reservationAndSelect: '選擇日期與時間',
      sessionBooked: '已訂滿',
      selectFlight: '選擇大師航線',
      flightDesc: '包含: 3-5分鐘航拍，手勢互動，拍照10張，手勢互動',
      selectDate: '請選擇預約日期',
      selectTime: '請選擇使用時間',
      toChangeTicket: '去改簽',
      toExchange: '去兌換',
      confirmReservation: '立即預訂',
      timeType: {
        morning: '晨光綺麗',
        noon: '烈日如畫',
        afternoon: '斜陽溫婉',
        evening: '暮色溫柔',
        night: '星輝熠熠',
      },
      reserved: '已預訂',
      selected: '已選',
      soldOut: '近期售罄',
      soldOutToday: '當天售罄',
      deviceUnavailable: '暫不可預訂',
      theParisianText: {
        confirmReservation: '不可在線預訂',
        tips: '請聯繫現場工作人員',
      },
      paymentPopup: {
        desc: '請在使用時間<span style="color: #FFF; font-size: 1.4rem; font-weight: 700; margin:0 0.8rem">開始前5分鐘</span>去訂單頁面。<br />點擊【一鍵航拍】或【掃碼航拍】使用；<br />現場若有工作人員，請直接請其協助操作。',
        desc2:
          '請<span style="color: #FFF; font-size: 1.4rem; font-weight: 700; margin:0 0.8rem">提前5分鐘</span>到打卡點。<br />找現場工作人員協助操作。',
      },
      verifyPopup: {
        title: '活動碼驗證',
        desc: '由於活動數量有限，請聯繫現場工作人員獲取驗證碼，驗證再預約。',
        placeholder: '輸入6位活動碼',
      },
      paymentUpdatePopup: {
        title: '支付升級中',
        desc: '請去微信/支付寶小程序下單',
      },
      otherBrowserPopup: {
        title: '去小程序預訂',
        desc: '請使用小程序預訂並體驗大師航拍服務',
      },
    },
  },
  memoryPage: {
    title: '打卡回憶',
    checkYourRecordAfterLogin: '登錄後查看打卡回憶',
    noHotpot: '還沒有打卡記錄',
    video: '視頻',
    photo: '照片',
    zhang: '張',
    duan: '段',
    photoProcessing: '照片處理中',
    photoProcessingError: '照片處理錯誤',
    photoProcessingExpired: '照片處理超時',
    unlockMore: '解鎖更多',
    moreTemplate: '更多模板',
    publish: '發佈航拍',
    publishPlaceholder: '說說您的心情，與更多人分享吧～',
    publishSuccess: '發佈成功',
    publishFailed: '發佈失敗',
    noRecord: '還沒有打卡記錄哦~',
    unlockToExperienceText: '免費體驗航拍，滿意再付費解鎖全部權益',
    hdPhotoText: '高清照片',
    unlockToGetText: '解鎖獲得',
    mediaResultCodeMap: {
      ORIGINAL_VIDEO: '原視頻',
      ORIGINAL_PIC: '原照片',
      CLIP_FAST_VIDEO: '快剪視頻',
      PREVIEW_VIDEO: '試看視頻',
      VIDEO_SUCCESS: '精剪視頻',
      VIDEO_SUCCESS_BEAUTY: '精剪視頻',
      FIX_CLIP: '混合剪輯',
      FIX_CLIP_BEAUTY: '混合剪輯',
      PAY_TEMP_VIDEO: '尊貴剪輯',
      PAY_TEMP_VIDEO_BEAUTY: '尊貴剪輯',
    },
    unlockedMedia: {
      title: '已獲得',
      desc1: '您已獲得高清照片',
      desc2: '，可下載',
    },
    lockedMedia: {
      title: '解鎖還可獲得',
      desc1: '全部權益',
      desc2: '統計中',
    },
    hotpotDetailPage: {
      title: '回憶詳情',
      processing: '處理中',
      videoProcessing: '視頻處理中',
      videoError: '視頻文件出錯，可嘗試下拉刷新',
      videoFail: '視頻剪輯失敗，可嘗試聯係客服',
      videoLost: '視頻丟失',
      noVideo: '無視頻',
      photoProcessing: '照片處理中',
      photoEmpty: '无照片',
      noMemory: '沒有回憶內容',
      downloadPhoto: '長按照片保存或分享~',
      pullrefresh: '下拉刷新',
      pullrefreshing: '正在刷新',
      easyRefresh: '鬆開刷新',
      refreshSuccess: '刷新完成',
      sampleVideo: '樣片',
    },
    videoPage: {
      title: '視頻下載',
      downloading: '下載中',
      click: '點擊右上角',
      openInBrower: '在默認瀏覽器打開',
      text: '該頁面<br />點擊下載並保存視頻',
    },
    cancelPublish: {
      title: '確定要取消嗎？',
      desc: '將不會在「航拍圈」展示',
      skipText: '暫不',
    },
    playbackLimit: {
      title: '前往詳情頁完成支付',
      desc: '領取高清照片/精美視頻',
      confirmText: '詳情頁',
    },
    sharePopup: {
      title: '共享專屬回憶',
      desc: '喊上朋友掃個碼，把這段回憶「搬」到 TA 的帳號裡～',
      desc2: '航拍完成起算，領取有效期為14天。',
    },
    createPoster: {
      poster: '海報',
      choosePhoto: '選擇照片',
      chooseTemplate: '海報模板',
      quoteTitle: '分享語錄',
      inputPlaceholder: '寫下你此時此刻的心動瞬間吧～',
      generate: '生成海報',
      generating: '生成中...',
      pleaseChoosePhoto: '請選擇照片',
      templateLoading: '模板載入中...',
      templateEmpty: '無模板',
      photoEmpty: '無照片',
      shareFriend: '分享好友',
      downloadPoster: '下載海報',
      close: '關閉',
      posterAlt: '生成海報',
      bgAlt: '背景圖',
      templateAlt: '模板圖',
      shareNotSupported: '當前瀏覽器不支援直接分享，請先下載海報再分享',
      generateFailed: '生成海報失敗，請稍後重試',
    },
    memoryItem: {
      trimmedVideo: '精剪影片',
      trimmedVideoDescription: '免費試看10秒・解鎖後可觀看完整影片+下載',
      quickVideo: '快剪影片',
      quickVideoDescription: '免費完整觀看・解鎖後可下載',
      experienceVoucher: '體驗券',
      experienceVoucherPopup: {
        subTitle: '免費體驗航拍，滿意再付費解鎖全部權益',
        skipBtnText: '取消',
        confirmBtnText: '去解鎖',
        benefitsTable: {
          type: '權益類型',
          locked: '未解鎖',
          unlocked: '解鎖後',
          photoTitle: '照片權益',
          photoLockedLine1: '可下載贈送的照片',
          photoUnlockedLine1: '全部高清照片下載',
          photoUnlockedLine2: '權限',
          videoTitle: '影片權益',
          videoLockedLine1: '試看影片 10 秒，',
          videoLockedLine2: '無法下載影片',
          videoUnlockedLine1: '精剪影片+快剪影片',
          videoUnlockedLine2: '（完整下載）',
          posterTitle: '分享海報',
          posterLocked: '不可使用海報功能',
          posterUnlocked: '眾多海報模板，一鍵生成精美海報',
          communityTitle: '發布航拍圈',
          communityLocked: '不可發布到航拍圈',
          communityUnlocked: '可發布到航拍圈，分享您的精彩時刻',
        },
      },
      videoEnded: {
        playEndedText: '已播放完',
        unlockToDownloadText: '解鎖後可下載視頻',
        unlockToGetVideoAndDownloadText: '解鎖後可獲得視頻下載',
        unlockToWatchText: '解鎖後可觀看完整視頻+下載',
        replayText: '重播視頻',
        unlockText: '立即解鎖',
        contactText: '請聯繫現場工作人員解鎖',
      },
    },
  },
  orderPage: {
    title: '訂單',
    checkOrderAfterLogin: '登錄後查看您的订单',
    noOrder: '當前還沒有航拍訂單',
    noClipOrder: '當前還沒有視頻剪輯訂單',
    flightOrders: '航拍訂單',
    videoOrders: '視頻剪輯',
    orderId: '訂單編號',
    paid: '已支付',
    fullRefund: '全額退款',
    partialRefund: '收取手續費{value}%，退款',
    shadow: '未支付',
    orderDetailPage: {
      title: '訂單詳情',
      goThere: '去這裡',
      paymentTime: '支付時間',
      exchangeTime: '兌換時間',
      startTime: '開始時間',
      endTime: '結束時間',
      refundDetails: '退款明細',
      paymentDetails: '支付明細',
      refundPrice: '退款金額',
      totalPrice: '總價',
      partialRefund: '本次退款需收取手續費{value}%',
      changeTicketLimit: '改簽已達上限次数',
      awaitingUseNote: {
        title: '待使用',
      },
      usedNote: {
        title: '已使用',
        desc: '感謝您使用，期待再次相遇',
      },
      expiredNote: {
        title: '已過期',
        desc: '已超過報到有效時限',
      },
      unfinishedNote: {
        title: '未完成',
        desc: '航拍失敗，建議改簽後再試',
      },
      cancelledNote: {
        title: '已取消',
        desc: '因天氣原因無法使用，已退款',
      },
      refundsProgressNote: {
        title: '退款中',
        desc: '已提交退款申請，系統核實中',
      },
      refundFailureNote: {
        title: '退款失敗',
        desc: '不符合退款條件，申請被駁回',
      },
      refundedNote: {
        title: '已退款',
        desc: '金額原路退回，請留意短信提示',
      },
      deviceErrorNote: {
        title: '未完成',
        desc: '因航拍遇到阻礙</br>支付金額將自動退款，請耐心等待',
      },
      skypathNotFound: '航線已下線',
      refundApplicationPopup: {
        title: '退款申請',
        dontWanaUse: '行程有變故/不想用了',
        nonFlyable: '天氣因素/空域管制/設備故障',
        unusedOvertime: '超時未使用',
        hazardousConditions: '使用過程中遇危險情況，未完成航拍',
        explanation: '說明原因狀況',
        systemCancel: '航拍失敗，訂單未完成',
        detailsDesc: '請這裡填寫原因以便我們瞭解情況',
        uploadPicture: '上傳圖片',
        parentheses: '(提高審核通過率，最多4張)',
        longText:
          '由於無人機飛行中會出現突發性的危險情況，需要終止航拍，本次退款將原路返還到您的支付賬號上。提交申請後請留意消息通知。',
        cancelledText: '由於系統繁忙導致航拍失敗，系統審核通過後，款項會原路退回。',
      },
      quesstionPopup: {
        title: '是否確認退款？',
        subTitle: '本次申請需要額外手續費{value}%作為商家損失費，<br />是否確定退款？',
      },
      feedbackPopup: {
        title: '提交成功',
        subTitle: '系統正在加速核實中',
        description: '審核通過後，將在7個工作日內原路退回。',
      },
    },
    orderStatus: {
      NOTIFICATION_TYPE_UNKNOWN: '未知',
      TICKET_TYPE_UNSPECIFIED: '未知',
      TICKET_TYPE_NEW: '待使用',
      TICKET_TYPE_COMPLETED: '已使用',
      TICKET_TYPE_ABORTED: '已使用',
      TICKET_TYPE_CHECKED: '待使用',
      TICKET_TYPE_EXPIRED: '已過期',
      TICKET_TYPE_CANCELLED: '未完成',
      TICKET_TYPE_DRC_INIT_FAILED: '未完成',
      TICKET_TYPE_LIVE_STREAM_FAILED: '未完成',
      TICKET_TYPE_LIVE_STREAM_PUSHED: '進行中',
      TICKET_TYPE_BAD_WEATHER: '已取消',
      TICKET_TYPE_REFUND_REQUESTED: '退款中',
      TICKET_TYPE_REFUND_REJECTED: '退款失敗',
      TICKET_TYPE_REFUND_ACCEPTED: '已退款',
      TICKET_TYPE_SHADOW: '未支付',
      UNKNOWN: '未知',
      UNPAID: '未支付',
      UNUSED: '待使用',
      USED: '已使用',
      EXPIRED: '已過期',
      REFUNDING: '退款中',
      REFUNDED: '已退款',
      REFUND_REJECTED: '退款失敗',
      LIVE_STREAM_PUSHED: '進行中',
      CHECKED: '已報到',
      UNFINISHED: '未完成',
    },
    clipOrderStatus: {
      EDIT_PENDING: '待剪辑',
      EDIT_COMPLETED: '已剪辑',
    },
  },
  profilePage: {
    switchLanguage: '切換語言',
    clickLogin: '點擊登錄',
    service: '聯繫客服',
    referrer: '推薦官',
    becomeReferrerPopup: {
      title: '成為推薦官',
      subTitle: '邀請新用戶下單能獲取獎勵。',
    },
    canceledReferrerPopup: {
      title: '已取消資格',
      subTitle: '如有疑惑請聯繫客服。',
    },
    referrerToast: {
      pendingReview: '審核中，請耐心等待',
      submitSuccess: '申請提交成功',
      toMiniProgramUse: '請到小程序使用相關功能',
      toMiniProgramSettle: '請到小程序申請結算',
    },
    referrerReviewStatus: {
      PENDING: '審核中',
      REJECTED: '審核不通過',
      CANCELLED: '已取消資格',
      DISABLED: '已取消資格',
    },
    userQrcodePopup: {
      share: ['點擊右上角', '分享'],
      tip: '掃一掃二維碼，邀請加入大師航拍',
    },
    bindShareMemoryPopup: {
      title: '您有未體驗的航拍',
      buttonText1: '去體驗航拍',
      buttonText2: '領取已有視頻/照片',
    },
    claimSuccessPopup: {
      title: '領取成功',
      desc: '已將影片/照片記錄在《我的-回憶》中',
    },
    SHARE_EXIST: {
      title: '回憶已收入囊中',
      desc: '這份回憶你已經領過啦，不用重複領取哦～',
      icon: 'normal',
    },
    SHARE_OWN_MEMORY_FORBIDDEN: {
      title: '領取提示',
      desc: '無法領取自己的回憶（影片/照片）哦～',
      icon: 'warning',
    },
    SHARE_ORDER_STATUS_ERROR: {
      title: '領取提示',
      desc: '無法領取該訂單的回憶（影片/照片）哦～',
      icon: 'warning',
    },
    SHARE_EXPIRED: {
      title: '領取超時',
      desc: '已超過14天領取有效期，無法領取~',
      icon: 'error',
    },
    claimFailedPopup: {
      title: '領取失敗',
      desc: '抱歉，領取時間已過，無法領取',
    },
    notice: '系統消息',
    setting: '設置',
    wechatUser: '微信用戶',
    toutiaoUser: '抖音用戶',
    aliUser: '支付寶用戶',
    anonymousUser: '匿名用戶',
    phoneNumberText: '請用小程序授權手機號',
    exchangeInputError: '請輸入正確的兌換碼',
    scanQRCodeFailed: '掃碼兌換碼失敗',
    exchangeInputPlaceholder: '請輸入兌換碼',
    servicePopup: {
      title: '微信客服',
      desc: '長按二維碼識別<br />為您提供快捷專屬的諮詢服務',
    },
    loginPopup: {
      content: '登錄後查看詳細',
    },
    noticePage: {
      title: '系統消息',
      viewDetails: '查看詳情',
      successfulBooking: '預訂成功',
      orderCanceled: '訂單已取消',
      refundRequestSubmittedSuccessfully: '退款申請提交成功',
      refundRequestFailed: '退款申請失敗',
      refundRequestApproved: '退款申請已通過',
      noNotice: '還沒有消息記錄',
      noticeDetailsPage: {
        title: '消息詳情',
      },
    },
    switchLanguagePage: {
      title: '切換語言',
      switchComplete: '切換完成',
    },
    settingPage: {
      title: '設置',
      account: '賬號',
      about: '關於',
      changePhoneNumber: '更改手機號',
      serviceAgreement: '用戶協議',
      privacyPolicy: '隱私政策',
      AboutMss: '關於大師航拍',
      writeoffAccount: '註銷賬號',
      popup: {
        title: '確定註銷賬號？',
        subTitle:
          '註銷成功後，將無法登錄或以任何方式使用当前账号，且後續無法恢復，請關注以下重要提醒：',
        deregisteredSuccessfully: '註銷成功',
        contenth3: '本次註銷具體包括如下信息',
        contentp1:
          '1.註銷賬號後以下信息將依照相關法律規定及協議約定，清空且無法恢復，包括個人信息、大師航拍賬號信息、訂單信息、航拍視頻/照片等。',
        contentp2: '2.在使用大師航拍服務中產生的交易金額，將不給予退還。',
      },
    },
    serviceAgreementPage: {
      title: '用戶協議',
    },
    privacyPolicyPage: {
      title: '隱私政策',
    },
    aboutMssPage: {
      title: '關於大師航拍',
      desc: '《旅遊景點共享無人機系統-大師航拍》：<br />是專為旅遊愛好者提供的全自動共享無人機服務。',
      slogan: '讓世界看見中國的美',
    },
    changePhoneNumberPage: {
      title: '更改手機號',
      newPhoneNumber: '請輸入新手機號碼',
      verifyCurrentPhone: '驗證當前手機並解綁',
      originalPhoneNumber: '請輸入原手機號碼',
      modifyPhoneBinding: '綁定新手機號',
      modifyPhoneBindingSuccess: '綁定新手機號成功',
      tips: '點擊下一步即爲解綁當前手機號',
      successToast: {
        title: '更改成功',
      },
      errorToast1: {
        title: '手機號已被使用',
      },
      errorToast2: {
        title: '短信服務錯誤',
      },
    },
  },
  loginPage: {
    loginLoad: '登錄中...',
    loginByWechat: '微信一鍵登錄',
    acceptInvitationLogin: '接受邀請並登錄',
    noLogin: '暫不登錄',
    weChatAuthorizedLogin: '微信授權登錄',
    phoneLogin: '手機登錄',
    phoneLoginTips: '新用戶驗證登錄即註冊',
    tipsText: '我已閱讀並同意',
    userAgreement: '《用戶協議》',
    privacyPolicy: '《隱私政策》',
    verificationCodeSend: '驗證碼已發送',
    verificationCodeExpired: '驗證碼已失效',
    verificationCodeError: '驗證碼錯誤',
    netWorkError: '網絡異常, 請稍後重試',
    popup: {
      title: '協議/政策',
      content:
        '為了更好的保障您的合法權益，請您閱讀並同意以下協議<span style="color: #016BFF"><span class="_terms">《用戶協議》</span> & <span class="_privacy">《隱私政策》</span></span>',
    },
    referrer: {
      title: '邀請人',
      notNewUser: '你已不是新用戶，無法被邀請',
      success: '你已成功被邀請',
      unableInviteMyself: '無法邀請自己',
    },
    smsCodePopup: {
      title: '請用上一個短信碼登錄',
      subTitle: '當天短信碼獲取到達上限',
    },
  },
  bindingPhonePage: {
    tips: '首次登錄需要綁定您的手機號',
    phone: '請輸入手機號碼',
    verificationCode: '請輸入短信驗證碼',
    getCode: '獲取驗證碼',
    getCodeAgain: '重新獲取',
    bindingPhone: '綁定手機',
    phoneError: '請輸入正確位數的手機號碼',
    areaCodeError: '請輸入正確的區號',
    noMatchCountry: '未找到匹配的國家',
    searchAreaCode: '搜索區號',
    unbindPhoneError: '該號碼與綁定號碼不一致，請重新輸入',
    verificationCodeError: '驗證碼錯誤，請重新輸入',
    successToast: {
      title: '綁定成功',
    },
    toast1: {
      title: '手機號已被綁定',
      content: '請更換手機號再嘗試',
    },
    toast2: {
      title: '短信驗證碼錯誤',
      content: '請重新獲取驗證碼',
    },
  },
  wechatPage: {
    title: '請使用微信訪問<span style="color: #42BDFF">大師航拍</span>',
    desc1: '用微信“掃一掃”，現場掃描打卡點上的二維碼即可進入大師航拍官網。',
    desc2: '在當前頁面截圖發送到微信聊天框，長按識別二維碼添加公眾號，在公眾號進入官網。',
  },
  tutorialsPage: {
    step1: {
      title: '航拍準備開始啦',
      description: '為保證良好的航拍體驗，請確保已站在腳印範圍',
    },
    step2: {
      title: '拍照操作',
      description1: '滑動操控幹可控制攝影角度，調整畫面位置。',
      description2: '上下拖動滾軸可放大/縮小，控制畫面變焦。',
      description3: '大師角度。',
      description4: '點擊回到系統設置好的最美鏡頭位置。',
      description5: '即將拍照',
      description6: '拍照',
      description7: '點拍照後會進入3秒面延時拍照',
    },
    step3: {
      title: '實時播報',
      description: '建議調大手機音量，留意語音提示',
    },
    step4: {
      title: '中斷航拍',
      description1: '點擊“中斷”按鈕退出本次航拍，視為航拍結束。',
      description2: '當前拍攝記錄會保存在回憶',
      description3:
        '如航拍中，無人機因外部因素遇到飛行危險，系統會自動中斷結束本次航拍，可到訂單申請退款。',
    },
    tutorialsPopup: {
      title: '航拍準備開始啦~',
      subTitle: '為保證良好的航拍體驗</br>請確保已站在腳印範圍',
      buttonText: '我已在腳印範圍內',
    },
    guideline: '指引',
    yourReservation: '您的預訂航拍',
    started: '已開始',
    asaPossible: '請盡快啟動航拍',
    yourReservationStill: '還有',
    keepInMind: '開始',
  },
  aerialPage: {
    resume: {
      flying: '航拍進行中',
      flyingWithTime: '航拍進行中 · 已飛 {time}',
      backToFlight: '返回航拍',
    },
    TAKE_OFF: '起飛',
    GO_HOME: '返航',
    FLYING: '航行',
    RECORDING: '錄影',
    USER_PHOTO: '自拍',
    CONTROL: '控飛',
    SYSTEM_PHOTO: '系統拍照',
    HOVERING_CONTROL: '懸停控飛',
    DRONE_STARTUP: '無人機開機',
    DOCK_COVER_OPEN: '開艙',
    PREPARE_FOR_TAKE_OFF: '起飛準備',
    TOUCH_SCREEN_SHOW_LIVE: '輕觸屏幕展示畫面',
    LIVE_SUCCESS: '無人機畫面連接成功',
    POOR_NETWORK_TOUCH_RECONNECT: '當前網絡不佳，點我重新連接',
    seizePower: '控制權已被接管',
    seizePowerBtn: '重新控制',
    connecting: '連接中...',
    airportLive: {
      connecting: '機場連接中',
      poorNetwork: '網絡不穩，重新連接',
    },
    step1: {
      name: '起飛',
    },
    step2: {
      name: '自拍及操控',
    },
    step3: {
      name: '航拍',
    },
    shotTips: '即將拍照',
    flightPoints: '航線節點',
    flightInitTips: '無人機啟動中',
    flightRecordTips: '航線正在錄影中，手動錄影不可用。',
    flightFinishPopup: {
      statusText: '您已完成本次航拍之旅',
      subTitle:
        '預計<span style="color: #FFF; font-size: 1.8rem; font-weight: 700; line-height: 2.6rem; margin:0 0.8rem">10分鐘後</span>圖片視頻會處理完成<br />並記錄在《回憶》中，請耐心等待~',
      subscribedText: '處理完通知我',
    },
    flightErrorPopup: {
      statusText: '航拍失敗',
      subTitle: '請<span style="color: #016BFF">改簽</span>後重飛，或到訂單詳情申請退款。',
      confirmBtnText: '去改簽',
      cancelBtnText: '去退款',
    },
    autoTakePhotoText: '準備進入<br />自動拍照啦~',
    networkAnomalyPopup: {
      title: '網路連接異常',
      subTitle: '抱歉，當前網絡連接出現異常<br />請重新連接或返回重新啟動航拍',
      confirmBtnText: '重新連接',
    },
    stopFlightPopup: {
      title: '是否强制中斷航拍？',
      subTitle: '強制中斷航拍將視為完成本次航拍，當前拍攝<br />內容會保存到《回憶》中。',
      content: '強制停止航拍將不能申請退款',
    },
    droneStartFailPopup: {
      title: '啟動航拍失敗',
      subTitle: '機場異常，請稍後重試！',
    },
    droneLowBattery: {
      title: '啟動航拍失敗',
      subTitle: '無人機充電中，請稍後重試！',
    },
    terminateFlightPopup: {
      title: '航拍終止提示',
      subTitle: '抱歉，由於無人機飛行中遇到危險情況，系統將<br />終止本次飛行任務。',
      content: '您可到訂單詳情中申請退款',
    },
    droneExecutingPopup: {
      title: '啟動航拍失敗',
      subTitle: '無人機航拍中，請稍後重試！',
      cancelBtnText: '返回',
      confirmBtnText: '重試',
    },
    thisLineFlyingPopup: {
      title: '啟動航拍失敗',
      subTitle: '航線繁忙，請稍後重試！',
      cancelBtnText: '返回',
      confirmBtnText: '重試',
    },
    noRtkPopup: {
      title: '啟動航拍失敗',
      subTitle: '機場未標定，請稍後重試！',
      cancelBtnText: '返回',
      confirmBtnText: '重試',
    },
    autoReturnPopup: {
      title: '航拍終止提示',
      subTitle:
        '航綫異常，無人機自動返航。<br />請<span style="color: #016BFF">改簽</span>後重飛，或到訂單詳情申請退款。',
      skipBtnText: '後自動結束',
    },
    recoveryFailPopup: {
      title: '航拍終止提示',
      subTitle:
        '無人機脫離航綫，結束航拍。<br />請<span style="color: #016BFF">改簽</span>後重飛，或到訂單詳情申請退款。',
      skipBtnText: '後自動結束',
    },
    takeOffFailedPopup: {
      title: '啟動航拍失敗',
      subTitle: '無人機指令異常，系統已自動退款！',
    },
    takeOffNoHeartbeatPopup: {
      title: '啟動航拍失敗',
      subTitle: '機場網路異常，系統已自動退款！',
    },
    takeOffNoFilePopup: {
      title: '啟動航拍失敗',
      subTitle: '航線異常，系統已自動退款！',
    },
    autoRefundPopup: {
      title: '啟動航拍失敗',
      subTitle: '訂單即將超時，系統已自動退款！',
    },
    unKnownPopup: {
      title: '啟動航拍失敗',
      subTitle: '系統繁忙，請稍後重試！',
    },
    beforeScheduledTimePopup: {
      title: '啟動航拍失敗',
      subTitle: '訂單預定時間未到，請稍後重試！',
    },
    liveStreamFailedPopup: {
      title: '啟動航拍失敗',
      subTitle: '直播失敗，請稍後重試！',
    },
    noInTaskPopup: {
      title: '無人機返航中',
      subTitle: '上一任務結束，正在回艙，請稍等再啟動！',
    },
    moreThanOneMinuteFailedPopup: {
      title: '啟動航拍失敗',
      subTitle: '機場網絡異常，建議重試或去<span style="color: #016BFF">改簽</span>後再試！',
      cancelBtnText: '去改簽',
      confirmBtnText: '重試',
    },
    lessThanOneMinuteFailedPopup: {
      title: '啟動航拍失敗',
      subTitle:
        '訂單即將超時，建議你<span style="color: #016BFF">改簽</span>後再試！</br>或到訂單詳情申請退款。',
      cancelBtnText: '去退款',
      confirmBtnText: '去改簽',
    },
    notCompleteStartPopup: {
      title: '航拍失敗',
      subTitle: '抱歉，將自動退款，原路退回帳戶上。',
    },
    skipFlightPopup: {
      title: '跳過節點提示',
      subTitle: '跳過將不能再體驗此節點功能（即當前節點時間）',
      content: '請謹慎確認',
      confirmBtnText: '繼續體驗',
      cancelBtnText: '確認跳過',
    },
    flightDescription: {
      default: '無人機啟動中，請耐心等待~',
      d0: '無人機正在從機場飛出',
      d1: '就位拍照',
      d2: '就位拍攝',
    },
    loadingToast: {
      photo: '已進入拍照',
      recording: '已進入航拍',
      exit: '航拍結束，正在退出',
    },
    switchText: {
      takePhoto: '自拍',
      control: '操控',
    },
    SKYSHOT_JOURNEY_INTERRUPTED:
      '機場異常，建議重試或去<span style="color: #016BFF">改簽</span>後再試！',
    SKYSHOT_JOURNEY_LIVE_STREAM_FAILED:
      '直播失敗，建議重試或去<span style="color: #016BFF">改簽</span>後再試！',
    SKYSHOT_JOURNEY_PUSH_LIVE_STREAM_FAILED:
      '直播失敗，建議重試或去<span style="color: #016BFF">改簽</span>後再試！',
    SKYSHOT_JOURNEY_EXECUTING: '無人機航拍中，請稍後再重試！',
    SKYSHOT_JOURNEY_BATTERY_NOT_ENOUGH:
      '無人機充電中，建議重試或去<span style="color: #016BFF">改簽</span>後再試！',
    SKYSHOT_JOURNEY_TAKEOFF_FAILED:
      '無人機指令異常，建議重試或去<span style="color: #016BFF">改簽</span>後再試！',
    SKYSHOT_JOURNEY_TAKEOFF_NO_HEARTBEAT:
      '機場網絡異常，建議重試或去<span style="color: #016BFF">改簽</span>後再試！',
    SKYSHOT_JOURNEY_TAKEOFF_NO_FILE:
      '航線異常，建議重試或去<span style="color: #016BFF">改簽</span>後再試！',
    SKYSHOT_JOURNEY_UNKNOWN: '系統繁忙，建議稍後再試！',
    SKYSHOT_JOURNEY_AGENT_NO_HEARTBEAT:
      '邊緣設備網絡異常，建議重試或去<span style="color: #016BFF">改簽</span>後再試！',
    SKYSHOT_JOURNEY_DOCK_NO_HEARTBEAT:
      '機場網絡異常，建議重試或去<span style="color: #016BFF">改簽</span>後再試！',
    // 不是網絡問題：航線綁的前置機和機場綁的前置機對不上，重試和改簽都不會好（mss-cloud#66）
    SKYSHOT_JOURNEY_AGENT_DOCK_NOT_BOUND:
      '該航線暫不可用，請聯絡現場工作人員協助處理！',
    // 機場在線但沒關聯無人機：同樣是配置問題，重試和改簽都不會好（mss-cloud#93 / h5#24）
    SKYSHOT_JOURNEY_DOCK_DRONE_NOT_BOUND:
      '該機場暫未關聯無人機，請聯絡現場工作人員協助處理！',
    TAKE_OFF_TIME_OUT: '超時未起飛，建議重試或去<span style="color: #016BFF">改簽</span>後再試！',
    START_FLY_CMD_FAIL:
      '下發起飛指令失敗，建議重試或去<span style="color: #016BFF">改簽</span>後再試！',
    DRONE_NOT_IN_DOCK:
      '無人機不在機艙內，建議重試或去<span style="color: #016BFF">改簽</span>後再試！',
    PICK_DOCK_FAIL: '連接機場失敗，建議重試或去<span style="color: #016BFF">改簽</span>後再試！',
    DJI_UPLOAD_LOG:
      '機場正在上傳日誌，建議重試或去<span style="color: #016BFF">改簽</span>後再試！',
    stillTime: '剩余時間',
    shootInSuccession: '連拍',
    joystickControl: {
      up: '上升',
      down: '下降',
      left: '左轉',
      right: '右轉',
    },
    droneControl: {
      up: '前進',
      down: '後退',
      left: '左飛',
      right: '右飛',
    },
    liveQuality: '直播</br>畫質',
    liveQualityValue: {
      auto: '自適應',
      smooth: '流暢',
      standard: '標清',
      hd: '高清',
      uhd: '超清',
    },
    controlTheGimbal: '滑動屏幕控制雲台',
    pausedControlTheGimbal: '已暫停，進入懸停控飛',
    gimbal: '雲台',
    refresh: '刷新',
    interrupted: '終止',
    live: '直播中',
  },
  actionsPage: {
    actionResolutionFail: '動作解析失敗',
    paramsResolutionFail: '參數解析失敗',
  },
  personalPage: {
    title: '個人資料',
    signature: {
      title: '編輯簽名',
      placeholder: '這個傢伙很酷，沒有寫簽名',
    },
  },
  community: {
    title: '評論',
    likeFailed: '點讚失敗，請重試',
    unlikeFailed: '取消點讚失敗，請重試',
    commentTitle: '發表評論',
    commentPlaceholder: '說說你的想法...',
    commentSuccess: '評論發表成功',
    commentFailed: '評論發表失敗，請重試',
    noComment: '還沒有評論哦~',
    shootSimilar: '拍同款',
  },
  common: {
    waylineSummary: {
      title: '包含',
      desc: '3-5分鐘航拍，手勢互動，拍照10張，手勢互動',
    },
    unknownError: '未知錯誤',
    expand: '展開',
    collect: '收起',
    hotspot: '打卡點',
    copy: '複製',
    copySuccess: '複製成功',
    copyFailed: '複製失敗',
    verifySuccess: '驗證成功',
    verifyFailed: '驗證失敗',
    loadError: '加載失敗，點擊重試',
    loadFailed: '加載失敗',
    retry: '重試',
    useDate: '使用日期',
    useTime: '使用時間',
    date: '日期',
    time: '時間',
    noMore: '沒有更多啦~',
    noData: '暫無數據',
    noContent: '當前還沒有內容哦~',
    unset: '未設置',
    experienceNow: '馬上體驗',
    alreadyExperience: '已體驗',
    myMemory: '我的回憶',
    purchaseNotes: {
      title: '購買須知',
      note1: '“使用時間”的前5分鐘即可提前使用航拍；',
      note2:
        '進入訂單頁點擊【一鍵航拍】或【掃碼航拍】使用；<br />現場若有工作人員，請直接請其協助操作。',
      note3: '超過“使用時間”5分鐘后，不能再使用航拍 ，且不可退改，請確認好時間後再行購買。',
      note4: '請找現場工作人員協助操作。',
      note5: '使用時間之前5分鐘至後5分鐘，例如12:15，<br />12:10- 12:20可使用。',
      note6: '超過使用時間區間5分鐘後將不可使用，視為放棄本次航拍。',
    },
    refundRules: {
      title: '退款規則',
      refundRequestTimeToUse: '申請退款距使用時間',
      unusedOvertime: '超時未使用（7個自然日內申請）',
      unusedOvertime2: '超時未使用（超過7個自然日未申請）',
      otherReason: '天氣因素/空域管制/設備故障',
      handlingFee: '手續費',
      verification: '核實通過',
      noRefund: '不予退款',
    },
    termsOfUse: {
      title: '使用須知',
      howToUse: {
        title: '如何使用',
        description:
          '進入訂單頁點擊【一鍵航拍】或【掃碼航拍】使用；<br />現場若有工作人員，請直接請其協助操作。',
        description2: '請找現場工作人員協助操作。',
      },
      timeOfUse: {
        title: '使用時間',
        description: '使用時間前5分鐘到後5分鐘，例如8:15，8:10 - 8:20可使用。',
        description2: '使用時間之前5分鐘至後5分鐘，例如12:15，12:10- 12:20<br />可使用。',
      },
      timeoutUnused: {
        title: '超時未使用',
        description: '超過使用時間5分鐘後講不可使用，視為放棄本次航拍。',
        description2: '超過使用時間區間5分鐘後將不可使用，視為放棄本次航拍。',
      },
      changeTicket: {
        title: '改簽說明',
        description:
          '1. 凡遇到航拍失敗的情況可免費改簽，最多改簽5次。<br />2. 航拍失敗後7個自然日內未申請改簽或退款，系統將自動<br />&nbsp&nbsp&nbsp&nbsp退款並關閉訂單。',
      },
    },
    servicePopup: {
      title: '微信客服',
      content: '長按二維碼識別</br>為您提供快捷專屬的諮詢服務',
    },
    authFailedPopup: {
      title: '賬號下線通知',
      subtitle: '當前賬號已超過登錄時效，請重新登錄',
    },
    accountFrozenPopup: {
      title: '賬號已被凍結',
      subtitle: '該賬號存在違規操作，已被凍結！</br>如有疑惑，請聯繫客服。',
    },
    h: '時',
    m: '分',
    hour: '小時',
    hourShort: '時',
    minuteShort: '分',
    minute: '分鐘',
    day: '天',
    ago: '前',
    just: '剛剛',
    more: '更多',
    about: '約',
    paymentSuccessful: '預訂成功',
    changeTicketSuccess: '改簽成功',
    changeTicketFailed: '改簽失敗',
    exchangeSuccess: '兌換成功',
    exchangeFailed: '兌換失敗',
    exchangeFailedDescription: '還沒有回憶視頻/照片，請稍後再領取。',
    exchangeFailedDescriptionExpired: '該卡券已過期，請使用其他卡券。',
    sessionNotAvailable: '當前時間已被預訂',
    subscribe: '訂閱通知',
    subscribed: '已訂閱通知',
    subscribeLoad: '訂閱中...',
    subscribeError: '訂閱失敗',
    paymentSuccessfulSubscribe: '到點通知我',
    current: '當前',
    backToToday: '回到<br />今天',
    Mon: '周一',
    Tue: '周二',
    Wed: '周三',
    Thu: '周四',
    Fri: '周五',
    Sat: '周六',
    Sun: '周日',
    Jan: '一月',
    Feb: '二月',
    Mar: '三月',
    Apr: '四月',
    May: '五月',
    Jun: '六月',
    Jul: '七月',
    Aug: '八月',
    Sep: '九月',
    Oct: '十月',
    Nov: '十一月',
    Dec: '十二月',
    male: '男',
    female: '女',
    hide: '不顯示',
    nickname: '昵稱',
    phone: '手機',
    gender: '性別',
    saveSuccess: '保存成功',
    saveFailed: '保存失敗',
    pleaseTryAgain: '請重試',
    requestFailed: '請求失敗，點擊重新加載',
    loading: '加載中',
    mapLoading: '地圖加載中',
    mapLoadFailed: '地圖加載失敗',
    bg: '背景圖',
    pullUpLoadMore: '上拉加載更多',
    scan: '掃一掃',
    scanSubTitle: '將二維碼放入框內，即可自動掃描',
    weixin: '微信',
    alipay: '支付寶',
    signature: '簽名',
    originalVideo: '原視頻',
    originalImage: '原照片',
    publishedCommunity: '已發佈航拍圈',
    publishToCommunity: '發佈到航拍圈',
    disabledPublishCommunity: '不可發佈航拍圈',
    viewOriginalImage: '查看原圖',
    viewThumbnail: '效果圖',
    later: '稍後',
  },
  buttonText: {
    confirm: '確定',
    cancel: '取消',
    back: '返回',
    backTryAgain: '返回重試',
    nextStep: '下一步',
    reservation: '預訂',
    confirmChangeTicket: '立即改簽',
    confirmExchange: '立即兌換',
    viewOrder: '查看訂單',
    aerialPhotographyGuide: '航拍指引',
    agreeAndLogin: '同意並登錄',
    toLogin: '去登錄',
    loginToReserve: '登錄後預訂航拍',
    reserveNow: '馬上預訂',
    downloadVideo: '下載視頻',
    downloading: '下載中',
    downloadAgain: '重新下載',
    download: '下載',
    share: '共享',
    gotIt: '我知道了',
    requestRefund: '申請退款',
    contactCustomerService: '聯繫客服',
    noApplication: '暫不申請',
    submitApplication: '提交申請',
    logout: '退出登錄',
    confirmSwitching: '確定切換',
    completionBonding: '完成綁定',
    agreeAndBind: '同意並綁定',
    login: '登錄',
    notApply: '不申請了',
    identifyAndApply: '確定並申請',
    thinkAbout: '我再想想',
    definitiveCancellation: '確定註銷',
    startupAerial: '啟動航拍',
    aerialInfoSynchronized: '航拍信息同步中',
    viewMemory: '查看回憶',
    breakAerial: '中斷航拍',
    breakAerialBr: '中斷<br />航拍',
    continueAerial: '繼續航拍',
    scanRightNow: '立即航拍',
    oneClickAerial: '一鍵航拍',
    scanAerial: '掃碼航拍',
    enterAerial: '進入航拍',
    changeTicket: '改簽',
    toChangeTicket: '去改簽',
    rescanQrcode: '重新掃碼',
    noStream: '畫面卡<br />請點我',
    confirmModification: '確認更改',
    skip: '跳過',
    prev: '上一頁',
    next: '下一頁',
    voucher: '卡券兌換',
    longPressSaveQrcode: '長按保存二維碼',
    saveImage: '保存圖片',
    shareFriends: '分享給好友',
    exchange: '兌換',
    toAppointment: '去預訂',
    appointmentShoot: '更換時間',
    shootNow: '預訂最近一班',
    purchase: '購買',
    gain: '獲取',
    loginToBook: '登錄預訂',
  },
  bookingCard: {
    oneClickStart: '一鍵啟動',
    loginToBook: '登錄後預訂',
    bookNow: '馬上預訂',
    scanAerial: '掃碼航拍',
    contactStaff: '請聯繫工作人員',
    moreOrders: '更多訂單',
  },
  other: {
    exitPreview: '秒後退出預覽',
  },
  countries: {
    // 亞洲地區
    china: '中國大陸',
    hongkong: '中國香港',
    taiwan: '中國台灣',
    macau: '中國澳門',
    singapore: '新加坡',
    japan: '日本',
    thailand: '泰國',
    malaysia: '馬來西亞',
    philippines: '菲律賓',
    australia: '澳大利亞',
    india: '印度',
    southkorea: '韓國',
    vietnam: '越南',
    indonesia: '印度尼西亞',
    myanmar: '緬甸',
    cambodia: '柬埔寨',
    laos: '老撾',
    brunei: '文萊',
    mongolia: '蒙古',
    kazakhstan: '哈薩克斯坦',
    kyrgyzstan: '吉爾吉斯斯坦',
    uzbekistan: '烏茲別克斯坦',
    tajikistan: '塔吉克斯坦',
    turkmenistan: '土庫曼斯坦',
    afghanistan: '阿富汗',
    pakistan: '巴基斯坦',
    bangladesh: '孟加拉國',
    srilanka: '斯里蘭卡',
    maldives: '馬爾代夫',
    nepal: '尼泊爾',
    bhutan: '不丹',
    iran: '伊朗',
    iraq: '伊拉克',
    israel: '以色列',
    jordan: '約旦',
    lebanon: '黎巴嫩',
    syria: '敘利亞',
    saudiarabia: '沙特阿拉伯',
    uae: '阿聯酋',
    qatar: '卡塔爾',
    kuwait: '科威特',
    bahrain: '巴林',
    oman: '阿曼',
    yemen: '也門',

    // 歐洲地區
    russia: '俄羅斯',
    uk: '英國',
    france: '法國',
    germany: '德國',
    italy: '意大利',
    spain: '西班牙',
    portugal: '葡萄牙',
    netherlands: '荷蘭',
    belgium: '比利時',
    switzerland: '瑞士',
    austria: '奧地利',
    sweden: '瑞典',
    norway: '挪威',
    denmark: '丹麥',
    finland: '芬蘭',
    poland: '波蘭',
    czech: '捷克',
    hungary: '匈牙利',
    romania: '羅馬尼亞',
    bulgaria: '保加利亞',
    croatia: '克羅地亞',
    serbia: '塞爾維亞',
    slovenia: '斯洛文尼亞',
    slovakia: '斯洛伐克',
    estonia: '愛沙尼亞',
    latvia: '拉脫維亞',
    lithuania: '立陶宛',
    greece: '希臘',
    turkey: '土耳其',
    ukraine: '烏克蘭',
    belarus: '白俄羅斯',
    moldova: '摩爾多瓦',
    albania: '阿爾巴尼亞',
    macedonia: '馬其頓',
    montenegro: '黑山',
    bosnia: '波黑',
    ireland: '愛爾蘭',
    iceland: '冰島',
    luxembourg: '盧森堡',
    malta: '馬耳他',
    cyprus: '塞浦路斯',
    monaco: '摩納哥',
    liechtenstein: '列支敦士登',
    andorra: '安道爾',
    sanmarino: '聖馬力諾',
    vatican: '梵蒂岡',

    // 北美洲
    us: '美國',
    canada: '加拿大',
    mexico: '墨西哥',
    guatemala: '危地馬拉',
    belize: '伯利茲',
    honduras: '洪都拉斯',
    elsalvador: '薩爾瓦多',
    nicaragua: '尼加拉瓜',
    costarica: '哥斯達黎加',
    panama: '巴拿馬',
    cuba: '古巴',
    jamaica: '牙買加',
    haiti: '海地',
    dominican: '多米尼加',
    puertorico: '波多黎各',

    // 南美洲
    brazil: '巴西',
    argentina: '阿根廷',
    chile: '智利',
    colombia: '哥倫比亞',
    peru: '秘魯',
    venezuela: '委內瑞拉',
    ecuador: '厄瓜多爾',
    bolivia: '玻利維亞',
    paraguay: '巴拉圭',
    uruguay: '烏拉圭',
    guyana: '圭亞那',
    suriname: '蘇里南',
    frenchguiana: '法屬圭亞那',

    // 非洲
    southafrica: '南非',
    egypt: '埃及',
    nigeria: '尼日利亞',
    kenya: '肯尼亞',
    morocco: '摩洛哥',
    algeria: '阿爾及利亞',
    tunisia: '突尼斯',
    libya: '利比亞',
    sudan: '蘇丹',
    ethiopia: '埃塞俄比亞',
    ghana: '加納',
    tanzania: '坦桑尼亞',
    uganda: '烏干達',
    zimbabwe: '津巴布韋',
    zambia: '贊比亞',
    botswana: '博茨瓦納',
    namibia: '納米比亞',
    angola: '安哥拉',
    mozambique: '莫桑比克',
    madagascar: '馬達加斯加',
    mauritius: '毛里求斯',
    seychelles: '塞舌爾',
    comoros: '科摩羅',
    djibouti: '吉布提',
    somalia: '索馬里',
    eritrea: '厄立特里亞',
    rwanda: '盧旺達',
    burundi: '布隆迪',
    malawi: '馬拉維',
    lesotho: '萊索托',
    swaziland: '斯威士蘭',
    cameroon: '喀麥隆',
    centralafrica: '中非',
    chad: '乍得',
    congo: '剛果',
    democraticcongo: '剛果民主共和國',
    gabon: '加蓬',
    equatorialguinea: '赤道幾內亞',
    sao: '聖多美和普林西比',
    guinea: '幾內亞',
    guineabissau: '幾內亞比紹',
    sierraleone: '塞拉利昂',
    liberia: '利比里亞',
    ivorycoast: '科特迪瓦',
    burkinafaso: '布基納法索',
    mali: '馬里',
    niger: '尼日爾',
    senegal: '塞內加爾',
    gambia: '岡比亞',
    capeverde: '佛得角',
    mauritania: '毛里塔尼亞',

    // 大洋洲
    newzealand: '新西蘭',
    fiji: '斐濟',
    papuanewguinea: '巴布亞新幾內亞',
    solomon: '所羅門群島',
    vanuatu: '瓦努阿圖',
    newcaledonia: '新喀里多尼亞',
    frenchpolynesia: '法屬波利尼西亞',
    samoa: '薩摩亞',
    tonga: '湯加',
    kiribati: '基里巴斯',
    tuvalu: '圖瓦盧',
    nauru: '瑙魯',
    palau: '帕勞',
    marshall: '馬紹爾群島',
    micronesia: '密克羅尼西亞',
    cookislands: '庫克群島',
    niue: '紐埃',
    tokelau: '托克勞',
    pitcairn: '皮特凱恩群島',

    // 加勒比海地區
    saintlucia: '聖盧西亞',
    saintvincent: '聖文森特和格林納丁斯',
    americansamoa: '美屬薩摩亞',
    saintkitts: '聖基茨和尼維斯',
    dominica: '多米尼克',
    britishvirginislands: '英屬維爾京群島',
    sintmaarten: '荷屬聖馬丁',
    turksandcaicos: '特克斯和凱科斯群島',
    usvirginislands: '美屬維爾京群島',

    // 特殊地區和島嶼
    jersey: '澤西',
    guernsey: '根西',
    isleofman: '馬恩島',
    alandislands: '奧蘭群島',
    svalbard: '斯瓦爾巴群島',
    mayotte: '馬約特',
    northmacedonia: '北馬其頓',
    southsudan: '南蘇丹',
    saintpierre: '聖皮埃爾和密克隆',
    guadeloupe: '瓜德羅普',
    saintmartin: '聖馬丁島',
    saintbarthelemy: '聖巴泰勒米',
    sinteustatius: '聖尤斯特歇斯',
    saba: '薩巴',
    bonaire: '博奈爾',
    curacao: '庫拉索',
    easttimor: '東帝汶',
    wallisandfutuna: '瓦利斯和富圖納',
    falklandislands: '福克蘭群島',
  },
}
